import { AnyAction } from 'redux';

import { CLEAR_INQUIRY_DATA } from '../../inquiry/actions/inquiry-actions';
import {
    CLEAR_OFFERS,
    OFFERS_NOT_FOUND,
    RECEIVE_OFFERS,
    REQUEST_OFFERS,
    UPDATE_OFFER_END,
    UPDATE_OFFER_START,
} from '../actions/offer-actions';
import { Inquiry } from '../../../common/models/inquiry';
import { OfferAccountPurchase } from '../../../common/models/offer-account-purchase';

export interface OffersReducerState {
    offerAccountPurchase: OfferAccountPurchase[];
    requesting: boolean;
    notFound: boolean;
    inquiry?: Inquiry;
}

const initialOffersReducerState: OffersReducerState = {
    offerAccountPurchase: [],
    requesting: false,
    inquiry: undefined,
    notFound: false,
};

export const offersReducer = (
    state: OffersReducerState = initialOffersReducerState,
    action: AnyAction
): OffersReducerState => {
    const { type, ...rest } = action;
    switch (type) {
        case RECEIVE_OFFERS: {
            return {
                ...state,
                offerAccountPurchase: [...rest['offerAccountPurchases']],
                inquiry: rest['inquiry'],
                requesting: false,
                notFound: false,
            };
        }

        case OFFERS_NOT_FOUND: {
            return {
                ...state,
                offerAccountPurchase: [],
                inquiry: undefined,
                requesting: false,
                notFound: true,
            };
        }

        case REQUEST_OFFERS: {
            return {
                ...state,
                requesting: true,
                notFound: false,
            };
        }

        case CLEAR_INQUIRY_DATA:
        case CLEAR_OFFERS: {
            return {
                ...initialOffersReducerState,
            };
        }

        case UPDATE_OFFER_END: {
            return {
                ...state,
                requesting: false,
            };
        }

        case UPDATE_OFFER_START: {
            return {
                ...state,
                requesting: true,
            };
        }

        default: {
            return state;
        }
    }
};
